import {ValidationError} from "../../../../types/types";
import {Text} from "@mantine/core";

export type ValidationErrorPros = {
    errors: ValidationError[]
}

export function ValidationErrorSection(props: ValidationErrorPros) {
    if (props.errors.length === 0) {
        return <></>;
    }

    return (
        <div className={"error-section"}>
            {props.errors.map(error => <Text key={"error-" + error.property}>{error.message}</Text>)}
        </div>
    );

}